import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface ILockerData {
  lock: boolean;
  tab: ScheduleTabTypes;
  segment: ScheduleSegmentTypes;
  filter: IPipelineOverviewScheduleFilterVO;
  timeChange: boolean;
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<any>;
type IClearLockerDataAction = Action<'clearLockerData'> & IPayload<unknown>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
    clearLockerData: Reducer<ILockerData, IClearLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-pipeline-overview-schedule-locker';

export const DEFAULT_FILTER: IPipelineOverviewScheduleFilterVO = {
  composedDatePicker: {
    granularity: 'quarter',
    date: ['', ''],
  },
  pteam: [],
  business_owner: [],
  studio: [],
  project: [],
  platform: [],
  milestone: [],
  publisher: [],
  status: [],
  stage: [],
  form: [],
};

const DEFAULT_LOCKER_DATA: ILockerData = {
  lock: false,
  tab: 'calendar-card',
  segment: '',
  filter: DEFAULT_FILTER,
  timeChange: false,
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload, lock: true };
    },
    clearLockerData(state) {
      return { ...state, ...DEFAULT_LOCKER_DATA, lock: false };
    },
  },
  effects: {},
};

export default LockerModel;
